<div class="row g-4 m-1">
    <div class="col-12 col-lg-8">

        <!-- Featured / Announcements Striped Accordion -->
        <!--<section class="mb-5">
            <h5 class="text-uppercase fw-bold text-muted mb-3">Featured & Announcements</h5>
            <div class="striped-accordion">
                @for(item of announcements(); track $index) {
                <div class="stripe-item" [style.background-image]="'url(' + item.image + ')'"
                    [routerLink]="['/home/news', item.id]">
                    <div class="stripe-title text-light">{{ item.category }}</div>
                    <div class="stripe-overlay">
                        <div class="stripe-content text-light">
                            <span class="badge bg-danger mb-2">{{ item.category }}</span>
                            <h4 class="fw-bold mb-1 text-truncate">{{ item.title }}</h4>
                            <small class="text-light text-opacity-75"><i class="bi bi-clock"></i> {{ item.timestamp
                                }}</small>
                        </div>
                    </div>
                </div>
                }
            </div>
        </section>-->
        <!-- ./Featured / Announcements -->

        <h5 class="text-uppercase fw-bold text-muted mb-3">Discover Lobbies</h5>

        <!--search-filters-->
        <div
            class="search-container d-flex flex-column flex-md-row gap-3 justify-content-between align-items-center mb-4">
            <div class="input-group sleek-search" style="max-width: 350px;">
                <span class="input-group-text"><i class="bi bi-search"></i></span>
                <input type="text" class="form-control" placeholder="Search lobbies..." [ngModel]="searchQuery()"
                    (ngModelChange)="searchQuery.set($event)">
            </div>
            <div class="d-flex gap-2 align-items-center">
                <div class="filter-toggle" role="group">
                    <button type="button" class="btn btn-sm" [class.active]="activeFilter() === 'All'"
                        (click)="setFilter('All')">All</button>
                    <button type="button" class="btn btn-sm" [class.active]="activeFilter() === 'Official'"
                        (click)="setFilter('Official')">Official</button>
                    <button type="button" class="btn btn-sm" [class.active]="activeFilter() === 'Community'"
                        (click)="setFilter('Community')">Community</button>
                </div>

                <div class="view-toggle ms-3" role="group">
                    <button type="button" class="btn btn-sm" [class.active]="viewMode() === 'grid'"
                        (click)="viewMode.set('grid')" title="Grid View">
                        <i class="bi bi-grid-fill"></i>
                    </button>
                    <button type="button" class="btn btn-sm" [class.active]="viewMode() === 'list'"
                        (click)="viewMode.set('list')" title="List View">
                        <i class="bi bi-list"></i>
                    </button>
                </div>
            </div>
        </div>
        <!--./search-filters-->

        <section class="mb-5">
            @if (loading()) {
            <div class="d-flex flex-column align-items-center justify-content-center py-5 text-muted">
                <div class="spinner-border mb-3" role="status"
                    style="border-color: #9f50ff transparent #9f50ff transparent; width: 2rem; height: 2rem;">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <small class="text-uppercase tracking-wider" style="font-size: 0.7rem;">Loading lobbies...</small>
            </div>
            } @else {
            @if(viewMode() === 'grid') {
            <!-- Grid View -->
            <div class="row row-cols-1 row-cols-md-2 row-cols-xxl-3 g-4">
                @for(lobby of filteredArenas(); track lobby.guid) {
                <div class="col">
                    <div class="card lobby-showcase-card h-100" routerLink="/home/chat/{{lobby.guid}}">
                        <div class="position-relative">
                            <img [src]="lobby.avatarURL || '/images/logo_1_2.png'" class="card-img-top" [alt]="lobby.title">
                            <div class="floating-badges">
                                <span class="badge-glass">{{ lobby.isOfficial ? 'Official' : 'Community' }}</span>
                                <span class="badge-glass text-warning"><i class="bi bi-people-fill me-1"></i> {{
                                    lobby.onlineUsers }}</span>
                            </div>
                        </div>
                        <div class="card-body d-flex flex-column">
                            <h5 class="card-title fw-bold text-truncate mb-2">{{ lobby.title }}</h5>
                            <p class="card-text small text-muted text-truncate mb-3">{{ lobby.description || 'Join our
                                lobby and have fun!' }}</p>
                            <button class="btn btn-join mt-auto">Join Lobby</button>
                        </div>
                    </div>
                </div>
                }
            </div>
            } @else {
            <!-- List View -->
            <div class="d-flex flex-column gap-3">
                @for(lobby of filteredArenas(); track lobby.guid) {
                <div class="lobby-list-item text-white" routerLink="/home/chat/{{lobby.guid}}">
                    <img [src]="lobby.avatarURL || '/images/logo_1_2.png'" class="lobby-list-img me-3" [alt]="lobby.title">
                    <div class="flex-grow-1 overflow-hidden">
                        <div class="d-flex align-items-center mb-1">
                            <h5 class="mb-0 fw-bold me-2 text-truncate">{{ lobby.title }}</h5>
                            @if(lobby.isOfficial) {
                            <i class="bi bi-patch-check-fill text-primary" title="Official"></i>
                            }
                        </div>
                        <div class="text-muted small text-truncate">{{ lobby.description || 'No description available.'
                            }}</div>
                    </div>
                    <div class="d-flex align-items-center ms-3 gap-4">
                        <div class="text-end">
                            <div class="fw-bold fs-5 text-warning">{{ lobby.onlineUsers }}</div>
                            <div class="text-muted small text-uppercase">Players</div>
                        </div>
                        <button class="btn btn-outline-light btn-sm rounded-pill px-3">Join</button>
                    </div>
                </div>
                }
            </div>
            }

            @if (filteredArenas().length == 0) {
            <div class="col-12 text-center text-muted py-5">
                <h5>No lobbies found.</h5>
                <p>Try adjusting your search or filter.</p>
            </div>
            }
            }
        </section>
    </div>

    <div class="col-12 col-lg-4">
        <!--recently-visited-->
        @if (lastPlayedArena().length > 0) {
        <section class="mb-5">
            <h5 class="text-uppercase fw-bold text-muted mb-3">Recently Visited</h5>
            <div class="d-flex flex-column gap-3">
                @for (arena of lastPlayedArena(); track arena.guid) {
                <div class="d-flex align-items-center p-3 rounded recent-item position-relative z-0">
                    <img [src]="arena.avatarURL || '/images/logo_1_2.png'" class="rounded-circle me-3 border border-dark" title="Lobby"
                        style="width: 45px; height: 45px; object-fit: cover;" [alt]="arena.title">
                    <div class="flex-grow-1 overflow-hidden">
                        <h6 class="fw-bold text-truncate mb-0 text-white">{{ arena.title }}</h6>
                        <small class="text-muted d-flex align-items-center">
                            <span class="text-success me-1">●</span> {{ arena.onlineUsers }} / 200
                        </small>
                    </div>
                    <a class="btn btn-sm btn-rejoin text-white fw-bold ms-2 rounded-pill px-3"
                        (click)="$event.stopPropagation();" routerLink="/home/chat/{{arena.guid}}">REJOIN</a>
                </div>
                }
            </div>
        </section>
        }
        <!--./recently-visited-->

        <!--spades-leaderboard-->
        <section class="mb-5">
            <h5 class="text-uppercase fw-bold text-muted mb-3 d-flex align-items-center justify-content-between">
                <span>Spades Leaderboard</span>
                <span class="badge bg-purple-glow text-uppercase border-0"
                    style="font-size: 0.7rem; padding: 0.25rem 0.6rem;">TOP PLAYERS</span>
            </h5>

            <div class="leaderboard-card">
                @if (leaderboardLoading()) {
                <div class="d-flex flex-column align-items-center justify-content-center py-4 text-muted">
                    <div class="spinner-border text-primary mb-2" role="status"
                        style="border-color: #9f50ff transparent #9f50ff transparent; width: 1.5rem; height: 1.5rem;">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <small class="text-uppercase tracking-wider" style="font-size: 0.7rem;">Loading rankings...</small>
                </div>
                } @else {
                <div class="leaderboard-list">
                    @for (player of leaderboard(); track player.id; let idx = $index) {
                    <div class="d-flex align-items-center p-3 leaderboard-item">
                        <!-- Rank Badge -->
                        <div class="rank-badge flex-shrink-0 me-3" [class.rank-1]="idx === 0" [class.rank-2]="idx === 1"
                            [class.rank-3]="idx === 2" [class.rank-other]="idx > 2">
                            {{ idx + 1 }}
                        </div>

                        <!-- Player details -->
                        <div class="flex-grow-1 overflow-hidden">
                            <h6 class="fw-bold text-truncate mb-0 text-white player-name">{{ player.nickname }}</h6>
                            <small class="text-muted d-flex align-items-center gap-2">
                                <span>W: <strong class="text-success">{{ player.gamesWon }}</strong></span>
                                <span>L: <strong class="text-danger">{{ player.gamesLost }}</strong></span>
                                <span>WR: <strong class="text-info">{{ player.gamesPlayed > 0 ? (player.gamesWon /
                                        player.gamesPlayed * 100 | number:'1.0-0') : 0 }}%</strong></span>
                            </small>
                        </div>

                        <!-- ELO Rating -->
                        <div class="text-end">
                            <div class="rating-value fs-5">{{ player.rating }}</div>
                            <div class="player-stat-label">Rating</div>
                        </div>
                    </div>
                    } @empty {
                    <div class="text-center text-muted py-4">
                        <i class="bi bi-suit-spade-fill fs-2 mb-2 d-block text-secondary"></i>
                        <h6>No spades rankings found.</h6>
                    </div>
                    }
                </div>
                }
            </div>
        </section>
        <!--./spades-leaderboard-->
    </div>
</div>